// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-teaser.eopoi-widget{overflow:inherit}.eopoi-teaser.eopoi-widget .v-card{height:100%}.eopoi-teaser.eopoi-widget .row{margin-top:auto!important;margin-bottom:auto!important}.eopoi-teaser.eopoi-widget .v-application--wrap{display:block;flex:inherit;min-height:auto;min-width:inherit;width:100%;overflow-x:hidden}.eopoi-teaser a.v-btn{border:inherit}.eopoi-teaser .webcam__label{top:50%;right:2%}.eopoi-teaser-container.is-mobile{padding:0!important}", ""]);
// Exports
module.exports = exports;
